import AlertsList from "./alertsList";
export default AlertsList;
